import React, { createContext, useContext } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Language } from './translations';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
interface LanguageProviderProps {
  children: ReactNode;
}
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const {
    lang: urlLang
  } = useParams<{
    lang: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const validLangs: Language[] = ['en', 'ua', 'ru', 'ro'];
  const currentLang: Language = validLangs.includes(urlLang as Language) ? urlLang as Language : 'en';
  const setLang = (newLang: Language) => {
    const pathParts = location.pathname.split('/');
    pathParts[1] = newLang;
    navigate(pathParts.join('/'));
  };
  return <LanguageContext.Provider value={{
    lang: currentLang,
    setLang
  }} data-id="element-468">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}